import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchListFilter'
})
export class SearchListFilterPipe implements PipeTransform {
  /**
   *
   * @param items
   * @param col
   * @param value
   */
  transform(items: any[], col: string, value?: any): any {
    if (!items) {
      return [];
    }
    if (!value) {
      return items;
    }

    value = value.toLowerCase();

    return items.filter((data: any) => {
      return JSON.stringify(data[col]).toLowerCase().includes(value);
    });
  }
}
